import React from "react";
import {useEffect} from "react";
import {useParams} from "react-router-dom";

import OpenSeaDragonViewer from "components/OpenSeaDragonViewer";

import PageWrapper from "components/PageWrapper";
import Loader from "../Home/molecules/loader";
import {fetchSlideById} from "../../shared/model/redux/slide-reducer";
import {markSlideAsViewed} from "../../shared/model/redux/slides-reducer";
import {useDispatch, useSelector} from "react-redux";

function ImageView() {
    const {slideId} = useParams();
    const dispatch = useDispatch();
    const loading = useSelector((store) => store.slide.loading);
    const isError = useSelector((store) => store.slide.isError);
    const slideData = useSelector((store) => store.slide.data);

    useEffect(() => {
        dispatch(fetchSlideById(slideId));
        // Отмечаем слайд как просмотренный при открытии страницы просмотра
        dispatch(markSlideAsViewed(parseInt(slideId)));
    }, [dispatch, slideId]);

    useEffect(() => {
        // Обновляем заголовок страницы при загрузке данных слайда
        if (!loading && !isError && slideData) {
            // Используем имя файла или ID слайда если имя недоступно
            const slideTitle = slideData.name || `Слайд ${slideId}`;
            document.title = slideTitle;
        } else if (isError) {
            document.title = "ПАТО - Слайд не найден";
        } else {
            document.title = "ПАТО - Загрузка...";
        }
    }, [loading, isError, slideData, slideId]);

    return (
        <PageWrapper>
            {loading && (<Loader/>)}
            {!loading && !isError && (<OpenSeaDragonViewer />)}
            {isError && (<h3>Этого слайда не существует</h3>)}
        </PageWrapper>
    );
}

export default ImageView;
